module.exports = __webpack_public_path__ + "img/LabelSourceArt.2aa4253b.webp";